export enum ProfileTier {
  CORPORATE = 'CORPORATE',
  ACCOUNT = 'FINNAIRID',
  BASIC = 'Basic',
  JUNIOR = 'Junior Plus',
  SILVER = 'Silver',
  GOLD = 'Gold',
  PLATINUM = 'Platinum',
  VIP = 'VIP',
  LUMO = 'LUMO',
}

export interface Profile {
  isLoggedIn: boolean;
  memberNumber?: string;
  awardPoints?: number;
  tier?: ProfileTier;
}
